import t from "./highrise1413.mjs";
function o(e) {
  return function(r) {
    return t(r, e);
  };
}
export {
  o as default
};
